import { getCommitSha } from "../../logging/getCommitSha";
import { getTareBridge } from "./getTareBridge";
import type { JSTReport } from "./JSTReport";

export async function report(payload: JSTReport): Promise<void> {
  await getTareBridge()?.report?.({
    ...payload,
    context: { ...payload.context, rnBundleVersion: getCommitSha() },
  });
}
